angular.module('core')
  .service('dblCookieService', [
    '$cookies',
    '$window',
    function(
      $cookies,
      $window) {

    var self = this;

    // returns deserialized item stored with setItem in session cookie storage
    self.getSessionItem = function (key) {
      return $cookies.get(key);
    };

    // set a value that will be serialized to session cookie storage
    self.setSessionItem = function (key, value) {
      $cookies.put(key, value);
    };

    // return the string value of the cookie
    self.getPermanent = function (key) {
      return $cookies.get(key);
    };

    self.setPermanent = function (key, value) {
        // DIY since Angular 1.3 $cookies doesn't seem to allow for expiration date to be set
        // TODO: maybe get a non-Angular cookie library if more cookie interaction is needed
        var encodedKeyValue = encodeURIComponent(key) + '=' + encodeURIComponent(value);
        var cookie = encodedKeyValue + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
        $window.document.cookie = cookie;
    };

    self.removePermanent = function (key) {
      $cookies.remove(key);
    };

  }]);
